import { z } from "zod";

export type VoiceChatToken = z.infer<typeof VoiceChatTokenSchema>;
export const VoiceChatTokenSchema = z.object({
  token: z.string(),
});
